import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
export function Oferta() {
  const items = ['Sistema completo', 'Calculadora de ingresos', 'Modelos de mensajes', 'Política lista para usar'];
  const handleCheckout = () => {
    window.location.href = 'https://checkout.sectordigital.online/cart/44028880519211:1';
  };
  return <section className="py-16 md:py-24 px-4 bg-[#0f4c5c] text-white relative" data-id="element-76">
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-77"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-79">
          <div className="inline-block bg-[#d4a017] text-white font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wide shadow-lg" data-id="element-80">
            💰 OFERTA
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight text-white" data-id="element-81">
            TODO LO QUE NECESITÁS PARA DEJAR DE PERDER DINERO EN TU CONSULTORIO
          </h2>
        </motion.div>

        <div id="compra" className="scroll-mt-8 bg-white text-slate-800 rounded-3xl shadow-2xl overflow-hidden max-w-2xl mx-auto border-4 border-[#d4a017]" data-id="element-82">
          <div className="bg-slate-50 p-8 text-center border-b border-slate-200" data-id="element-83">
            <h3 className="text-2xl md:text-3xl font-bold text-[#0f4c5c]" data-id="element-84">
              KIT CONSULTORIO PRO
            </h3>
          </div>

          <div className="p-8 md:p-10" data-id="element-85">
            <div className="space-y-4 mb-10" data-id="element-86">
              {items.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-87">
                  <div className="bg-green-100 rounded-full p-1" data-id="element-88">
                    <Check className="w-5 h-5 text-green-600" strokeWidth={3} data-id="element-89" />
                  </div>
                  <span className="text-lg font-medium" data-id="element-90">{item}</span>
                </div>)}
            </div>

            <div className="text-center mb-8" data-id="element-91">
              <p className="text-slate-500 font-medium uppercase tracking-wide mb-2" data-id="element-92">
                PRECIO:
              </p>
              <div className="flex flex-col items-center justify-center mb-2" data-id="element-93">
                <span className="text-xl md:text-2xl text-slate-400 line-through font-bold decoration-red-500 decoration-[3px] mb-1" data-id="element-94">
                  $49.990
                </span>
                <span className="text-4xl md:text-6xl font-bold text-[#0f4c5c] leading-none" data-id="element-95">
                  $19.900 <span className="text-2xl md:text-3xl" data-id="element-96">ARS</span>
                </span>
              </div>
              <p className="text-slate-600 font-medium" data-id="element-97">
                Pago único · Sin suscripciones
              </p>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={handleCheckout} className="w-full bg-[#d4a017] hover:bg-[#c29215] text-white font-bold py-5 px-8 rounded-xl text-xl md:text-2xl transition-colors shadow-lg flex flex-col items-center justify-center gap-1" data-id="element-98">
              <span data-id="element-99">👉 SÍ, QUIERO EL KIT AHORA</span>
              <span className="text-sm font-medium text-white/90" data-id="element-100">
                Click aquí para acceder
              </span>
            </motion.button>

            <div className="mt-6 flex items-center justify-center gap-2 text-slate-500 text-sm font-medium" data-id="element-101">
              <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-102" />
              <span data-id="element-103">Pago 100% seguro y encriptado</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}